"use client"
import styled from "@emotion/styled"
import { Container, NewText, PdfIcon } from "ui"
import { sharedColors } from "ui/theme/colors"
import { extractProperty, getUmbracoPDFUrl } from "utils"

import { Divider } from "@mui/material"
import Link from "next/link"
import React from "react"
import "swiper/css"
import { Swiper, SwiperSlide } from "swiper/react"
import colors from "theme/colors"

const StyledCardContainer = styled.div`
  display: flex;
  width: 224px;
  height: 148px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid var(--Grey, #6f6f6f);
  background: var(--White, #fff);
`

const StyledCardBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const StyledSwiper = styled(Swiper)<{ borderB?: boolean }>`
  border-bottom: ${(props) =>
    props.borderB
      ? `
    1px solid #6f6f6f
  `
      : "none"};
`

const Box = styled.div`
  padding-top: 32px;
`
type Props = {
  data: any
  hasBoldDescription: boolean
  borderB?: boolean
  view: string
}

const Reports: React.FC<Props> = ({ data, hasBoldDescription, borderB, view }) => {
  const title = extractProperty(data, "title")
  const content = extractProperty(data, "content")
  const reportSliderData = extractProperty(data, "reportSlider").map((item: any) => {
    return {
      reportName: extractProperty(item, "reportName"),
      date: extractProperty(item, "date"),
      reportFile: extractProperty(item, "reportFile"),
    }
  })

  const subTitle2 = extractProperty(data, "subTitle2")
  const reportSlider2 = extractProperty(data, "reportSlider2")

  const reportSliderData2 = reportSlider2
    ? reportSlider2.map((item: any) => {
        return {
          reportName: extractProperty(item, "reportName"),
          date: extractProperty(item, "date"),
          reportFile: extractProperty(item, "reportFile"),
        }
      })
    : []

  const combinedReportSliderData = [
    {
      title: title,
      content: content,
      data: [...reportSliderData],
    },
    {
      content: subTitle2,
      data: [...reportSliderData2],
    },
  ]
  const renderDate = (itemDate: string) => {
    const date = new Date(itemDate)
    const yyyy = date.getFullYear()
    const mm = date.getMonth() + 1
    const dd = date.getDate()

    const formattedDate = dd + "." + mm + "." + yyyy
    return formattedDate
  }

  return (
    <Box>
      {combinedReportSliderData.map((i: any, index: number) => {
        if (i.data?.length === 0) {
          return null
        }
        return (
          <React.Fragment key={index.toString()}>
            <Container>
              {i?.title && (
                <NewText
                  desktopFontSize={16}
                  desktopFontWeight="400"
                  desktopLineHeight="23px"
                  mobileFontSize={14}
                  mobileFontWeight="400"
                  mobileLineHeight={"20px"}
                  component="div"
                  color={sharedColors.black}
                  dangerouslySetInnerHTML={{ __html: i?.title }}
                  margin={0}
                />
              )}
              {i?.content && (
                <NewText
                  desktopFontSize={18}
                  desktopFontWeight={hasBoldDescription ? "600" : "400"}
                  desktopLineHeight={hasBoldDescription ? "23px" : "26px"}
                  mobileFontSize={16}
                  mobileLineHeight={"23px"}
                  component="div"
                  color={sharedColors.black}
                  dangerouslySetInnerHTML={{ __html: i.content }}
                  margin={0}
                  marginTop={"24px"}
                  maxWidth="800px"
                />
              )}
            </Container>
            <Container forSwiper>
              <StyledSwiper
                spaceBetween={16}
                style={{ padding: "16px 16px 32px 16px" }}
                slidesPerView={"auto"}
              >
                {i?.data?.map((i: any, k: number) => (
                  <SwiperSlide key={k.toString()} style={{ width: "224px" }}>
                    <StyledCardContainer>
                      <NewText
                        desktopFontSize={14}
                        desktopFontWeight="400"
                        desktopLineHeight="100%"
                        mobileFontSize={12}
                        mobileFontWeight="400"
                        mobileLineHeight={"125%"}
                        component="div"
                        color={sharedColors.black}
                        dangerouslySetInnerHTML={{ __html: i.reportName }}
                        margin={0}
                      />
                      <StyledCardBottomContainer>
                        {i.date && (
                          <NewText
                            desktopFontSize={18}
                            desktopFontWeight="400"
                            desktopLineHeight="100%"
                            mobileFontSize={16}
                            mobileFontWeight="400"
                            mobileLineHeight={"125%"}
                            component="p"
                            color={"#6F6F6F"}
                            margin={0}
                          >
                            {renderDate(i.date)}
                          </NewText>
                        )}
                        <Link
                          href={getUmbracoPDFUrl(i.reportFile[0]?.url) || ""}
                          target={"_blank"}
                          style={{
                            display: "flex",
                            textDecoration: "none",
                            marginInlineStart: "auto",
                          }}
                        >
                          <PdfIcon
                            style={{
                              marginInlineEnd: "4px",
                              marginInlineStart: "auto",
                            }}
                          />
                          <NewText
                            desktopFontSize={14}
                            desktopFontWeight="400"
                            desktopLineHeight="100%"
                            mobileFontSize={12}
                            mobileFontWeight="400"
                            mobileLineHeight={"125%"}
                            component="p"
                            color={sharedColors.propBlue}
                            margin={0}
                          >
                            {view}
                          </NewText>
                        </Link>
                      </StyledCardBottomContainer>
                    </StyledCardContainer>
                  </SwiperSlide>
                ))}
              </StyledSwiper>
            </Container>
            {borderB ? (
              <Container>
                <Divider color={colors.black} />
              </Container>
            ) : null}
          </React.Fragment>
        )
      })}
    </Box>
  )
}
export default Reports
